module.exports = __webpack_public_path__ + "img/4_brendan_d.6453b40c.png";